import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Logout = () => {
    const navigate = useNavigate();
    const { signOut } = useAuth();

    useEffect(() => {
        let mounted = true;

        const run = async () => {
            await signOut();
            if (mounted) {
                navigate('/main', { replace: true });
            }
        };

        run();

        return () => {
            mounted = false;
        };
    }, [navigate, signOut]);

    return null;
};

export default Logout;
